import React, { Component } from 'react';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import { withTranslation, Trans } from 'react-i18next';
import TransomConfigurator from './../TransomConfigurator';
import MaterialSelector from '../MaterialSelector';
import Dropdown from '../Dropdown';
import './X43Transom.css';
import width from '../assets/Width.png';
import height from '../assets/Height.png';
import { view03ImageOptions } from './views/view03'

class Transom extends Component {
    constructor(props) {
        super(props);

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleNameFontChange = this.handleNameFontChange.bind(this);
        this.handleNameSizeChange = this.handleNameSizeChange.bind(this);
        this.handleNameColorChange = this.handleNameColorChange.bind(this);
        this.handleNameHorizontalOffsetChange = this.handleNameHorizontalOffsetChange.bind(this);
        this.handleNameVerticalOffsetChange = this.handleNameVerticalOffsetChange.bind(this);

        this.handlePortChange = this.handlePortChange.bind(this);
        this.handlePortFontChange = this.handlePortFontChange.bind(this);
        this.handlePortSizeChange = this.handlePortSizeChange.bind(this);
        this.handlePortColorChange = this.handlePortColorChange.bind(this);
        this.handlePortHorizontalOffsetChange = this.handlePortHorizontalOffsetChange.bind(this);
        this.handlePortVerticalOffsetChange = this.handlePortVerticalOffsetChange.bind(this);
    }

    handleNameChange(event) {
        let transom = this.props.transom;
        transom.Name.value = event.target.value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handleNameFontChange(value) {
        let transom = this.props.transom;
        transom.Name.font = value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handleNameSizeChange(value) {
        let transom = this.props.transom;
        transom.Name.size = value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handleNameColorChange(value) {
        let transom = this.props.transom;
        transom.Name.color = value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handleNameHorizontalOffsetChange(event) {
        let transom = this.props.transom;
        transom.Name.horizontalOffset = event.target.value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handleNameVerticalOffsetChange(event) {
        let transom = this.props.transom;
        transom.Name.verticalOffset = event.target.value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }



    handlePortChange(event) {
        let transom = this.props.transom;
        transom.Port.value = event.target.value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handlePortFontChange(value) {
        let transom = this.props.transom;
        transom.Port.font = value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handlePortSizeChange(value) {
        let transom = this.props.transom;
        transom.Port.size = value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handlePortColorChange(value) {
        let transom = this.props.transom;
        transom.Port.color = value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handlePortHorizontalOffsetChange(event) {
        let transom = this.props.transom;
        transom.Port.horizontalOffset = event.target.value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    handlePortVerticalOffsetChange(event) {
        let transom = this.props.transom;
        transom.Port.verticalOffset = event.target.value;

        if (this.props.onChange) {
            this.props.onChange(transom);
        }
    }

    render() {
        let imageOptions = view03ImageOptions;

        let labelStyle = {
            display: 'inline-block',
            width: 100,
            marginBottom: 16
        };

        let dropdownStyle = {
            width: 360,
            maxWidth: '100%'
        };

        let image = (
            <TransomConfigurator colorMultiplier={1.0} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2800, height: 570 }} transform={
                [
                    0.214815, 0, 0, 0,
                    0, 0.24, 0, 0,
                    0, 0, 1, 0,
                    205, 320, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        let footer = (
            <div className="x43transom">
                <h2><Trans defaults='Adjust position' /></h2>
                <div>
                    <h3><Trans defaults='Yacht Name Position' /></h3>
                    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 30 }}>
                        <img alt="Width" src={width} style={{ width: 'auto', marginRight: 10 }} />
                        <input style={{ flexGrow: 1 }} type="range" min="-1200" max="1200" value={this.props.transom.Name.horizontalOffset} onChange={this.handleNameHorizontalOffsetChange} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 30 }}>
                        <img alt="Height" src={height} style={{ width: 'auto', marginRight: 10 }} />
                        <input style={{ flexGrow: 1 }} type="range" min="0" max="500" value={this.props.transom.Name.verticalOffset} onChange={this.handleNameVerticalOffsetChange} />
                    </div>
                </div>
                <div>
                    <h3><Trans defaults='Harbor Name Position' /></h3>
                    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 30 }}>
                        <img alt="Width" src={width} style={{ width: 'auto', marginRight: 10 }} />
                        <input style={{ flexGrow: 1 }} type="range" min="-1200" max="1200" value={this.props.transom.Port.horizontalOffset} onChange={this.handlePortHorizontalOffsetChange} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 30 }}>
                        <img alt="Height" src={height} style={{ width: 'auto', marginRight: 10 }} />
                        <input style={{ flexGrow: 1 }} type="range" min="0" max="547" value={this.props.transom.Port.verticalOffset} onChange={this.handlePortVerticalOffsetChange} />
                    </div>
                </div>
            </div>
        );

        return (
            <ConfiguratorSection image={image} footer={footer}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Boat name' /></h1>

                    <p><Trans defaults='At this step, you can generate your own boat name. We recommend that the boat name takes up at least 1/3 of the transom and maximum 2/3. Home port should take up 2/3 of the boat name as a maximum.' /></p>
                    <p><Trans defaults='We also recommend that the boat name has the same color as the water lines. If you want the name to take up more space on the transom, you can always insert space in between the letters as an alternative to increase the size of the font.' /></p>

                    <input type="text" placeholder={this.props.t("My Yacht")} value={this.props.transom.Name.value} onChange={this.handleNameChange} /><br />
                    <input type="text" placeholder={this.props.t("My Harbor (optional)")} value={this.props.transom.Port.value} onChange={this.handlePortChange} />

                    <h3><Trans defaults='Yacht Name Options' /></h3>

                    <label style={labelStyle}><Trans defaults='Font' /></label>
                    <Dropdown style={dropdownStyle} small options={this.props.fontOptions} value={this.props.transom.Name.font} onChange={this.handleNameFontChange} /><br />

                    <label style={labelStyle}>Size</label>
                    <Dropdown style={dropdownStyle} small options={this.props.sizeOptions} value={this.props.transom.Name.size} onChange={this.handleNameSizeChange} /><br />

                    <label style={labelStyle}>Color</label>
                    <MaterialSelector options={this.props.colorOptions} value={this.props.transom.Name.color} onChange={this.handleNameColorChange} label={this.props.transom.Name.color.label} /><br />

                    <h3><Trans defaults='Harbor Name Options' /></h3>

                    <label style={labelStyle}>Font</label>
                    <Dropdown style={dropdownStyle} small options={this.props.fontOptions} value={this.props.transom.Port.font} onChange={this.handlePortFontChange} /><br />

                    <label style={labelStyle}>Size</label>
                    <Dropdown style={dropdownStyle} small options={this.props.sizeOptions} value={this.props.transom.Port.size} onChange={this.handlePortSizeChange} /><br />

                    <label style={labelStyle}>Color</label>
                    <MaterialSelector options={this.props.colorOptions} value={this.props.transom.Port.color} onChange={this.handlePortColorChange} label={this.props.transom.Port.color.label} /><br />

                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Transom);


// WEBPACK FOOTER //
// ./src/X43MK2/Transom.js